import api from "../configurations/http-common";

export const applicationConfigsApi = async () => {
  return api.securedAxios().get("/api/v2.0/getConfigs");
};

export const getVersionCode = async () => {
  return api.securedAxios().get("/web/system/info");
};
